// take in a word and a count, and return the pluralized version of the word
export const pluralize = (count: number, noun: string, suffix = 's'): string =>
  `${noun}${count !== 1 ? suffix : ''}`;
